/**
 * 1등급 전용 로더 — 모든 로딩 화면 공통
 * "1등급" 워드마크 세 글자가 순서대로 통통 튄다.
 * fullscreen: 화면 전체 세로 중앙 정렬 (학원 상세 진입 등)
 */
import React from 'react';
import styled, { keyframes } from 'styled-components';

const CHARS = ['1', '등', '급'];

const BrandLoader = ({ size = 30, fullscreen = false }) => (
  <Wrap $full={fullscreen}>
    {CHARS.map((c, i) => (
      <Ch key={i} $size={size} style={{ animationDelay: `${i * 0.13}s` }}>{c}</Ch>
    ))}
  </Wrap>
);

export default BrandLoader;

const bounce = keyframes`
  0%, 70%, 100% { transform: translateY(0); opacity: 0.4; }
  35%           { transform: translateY(-10px); opacity: 1; }
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  ${({ $full }) => ($full ? 'min-height: 100vh;' : 'padding: 72px 0;')}
`;

const Ch = styled.span`
  font-size: ${({ $size }) => $size}px;
  font-weight: 800;
  line-height: 1;
  color: ${({ theme }) => theme.colors.primary};
  animation: ${bounce} 1.2s ease-in-out infinite;
`;
